import { Component, OnInit } from '@angular/core';
import {
	FormControl,
	FormGroup
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENANT } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';

import { User } from 'src/app/shared/models/security/user';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { PrestationFichier } from 'src/app/shared/models/prestationFichier';
import { Prestation } from 'src/app/shared/models/prestation';
import { NotificationEmail, SendEmail } from 'src/app/shared/models/notificationEmail';
import { NotificationType, NotificationTypeEnum } from 'src/app/shared/enums/notification-type.enum';

@Component({
	selector: 'app-prestationFichier-modal-ajout',
	templateUrl: './prestationFichier-modal-ajout.component.html',
	styleUrls: ['./prestationFichier-modal-ajout.component.scss']
})
export class PrestationFichierModalAjoutComponent implements OnInit {
	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked: { value: boolean } = { value: false };

	LABEL_INTERVENANT: string;

	MAX_NAME_CHAR = 25;
	NAME_PATTERN = new RegExp("^[0-9a-zA-Z,.'éèàçÀÆæÇÉÈŒœÙ-]+$");
	PHONE_NUMBER_PATTERN = '0{1}[0-9]{9}';

	formAjout: FormGroup = new FormGroup(
		{
			typeDocument: new FormControl(''),
		}
	);

	prestation: Prestation = null;
	user: User;
	prestationFichier = new PrestationFichier();
	notificationEmail : NotificationEmail;
	listNotificationType = NotificationType;
	sendMail = new SendEmail();

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private logger: LogService,
		private facade: FacadeService,
		public bsModalRef: BsModalRef
	) {}

	ngOnInit(): void {
		this.LABEL_INTERVENANT = this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
		this.user = this.facade.dataStorageService.getUser();
		if (this.user) {
			//this.center = this.user.prestationFichier.serviceCenter;
		}

		const prestationId = +this.router.url.split('/').pop();
		this.facade.prestationService
			.getPrestationById(prestationId)
			.subscribe((prestation: Prestation) => {
				this.prestation = prestation;
			});
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		console.log(this.prestationFichier);
		this.facade.prestationFichierService.addPrestationFichier(this.prestationFichier).subscribe({
			next: (val) => {
				console.log(this.prestationFichier);
				this.facade.prestationFichierService.uploadFile(this.prestationFichier.file, val.id).subscribe({
					complete: () => {
						this.bsModalRef.hide();
						this.isValidateButtonClicked.value = false;
						this.reload();
					},
					error: (err) => {
						console.log(err);
						this.facade.prestationFichierService.deletePrestationFichier(val.id).subscribe({
							complete: () => {
								this.isValidateButtonClicked.value = false;
								this.facade.toastService.createHttpErrorToast(
									err.error.message,
									err.status
								);
							}
						});
					}
				})
			},
			error: (err: ErrorResponse) => {
				console.log(err);
				this.isValidateButtonClicked.value = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message,
					err.status
				);
			}
		});
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}
}

